[
  {
    "id": 1,
    "title": "plan-1-title",
    "description": "plan-1-description",
    "price": "plan-1-price",
    "priceTime": "plan-1-price-time",
    "features": [
      "online-store",
      "unlimited-branches",
      "unlimited-team-members",
      "unlimited-third-parties",
      "products",
      "orders",
      "third-party-delivery-option",
      "own-delivery-team-option",
      "mobile-app-for-delivery-team",
      "analytics",
      "merchants-and-delivery-companies"
    ]
  },
  {
    "id": 2,
    "title": "plan-2-title",
    "description": "plan-2-description",
    "price": "plan-2-price",
    "priceTime": "plan-2-price-time",
    "features": [
      "online-store",
      "max-branches",
      "unlimited-team-members",
      "max-third-parties",
      "products",
      "orders",
      "third-party-delivery-option",
      "own-delivery-team-option",
      "mobile-app-for-delivery-team",
      "only-for-merchants"
    ]
  },
  {
    "id": 3,
    "title": "plan-3-title",
    "description": "plan-3-description",
    "price": "plan-3-price",
    "priceTime": "plan-3-price-time",
    "features": [
      "online-store",
      "unlimited-branches",
      "unlimited-team-members",
      "unlimited-third-parties",
      "products",
      "orders",
      "third-party-delivery-option",
      "own-delivery-team-option",
      "mobile-app-for-delivery-team",
      "analytics",
      "only-for-merchants"
    ]
  }
]
